<template>
  <div  >
    <div :id="pieId" class="pie" v-if="data && data.length > 0"></div>
    <div class="loading" v-else>

    </div>
  </div>
</template>
<script>
import { Chart } from "@antv/g2";

export default {
  components: {},
  props: {
    pieId: {
      type: String,
      default: "pie",
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pieChart: null,
      loading: false,
    };
  },
  created() {
    
  },
  watch: {
    data: {
      handler: function(newVal, oldVal) {
        if (!this.pieChart) {
          this.$nextTick(() => {
            this.drawPieChart();
          });
        } else {
          const pieData = this.dealData(newVal);
          this.pieChart.changeData(pieData);
        }
      },
    },
  },
  activated() {},
  computed: {},
  methods: {
    drawPieChart() {
      if (!this.data || this.data.length == 0) return;
      const chart = new Chart({
        container: this.pieId,
        autoFit: true,
        height: 360,
      });
      // 新建一个 view 用来单独渲染Annotation
      const innerView = chart.createView();
      chart.coordinate("theta", {
        radius: 0.8,
        innerRadius: 0.65,
      });
      const pieData = this.dealData(this.data);
      chart.data(pieData);
      chart.tooltip({
        showMarkers: false,
        showTitle: false,
        customItems: (items) => {
          items[0].value = parseInt(items[0].value);
          return items;
        },
      });
      // 声明需要进行自定义图例字段： 'item'
      chart.legend({
        flipPage: false,
      });

      chart
        .interval()
        .adjust("stack")
        .position("value")
        .color("name", [
          "#1890FF", "#36CBCB", "#4ECB74", "#FFBE4B", "#F2637B", 
          "#48A7D0", "#6C8DE0", "#F09666", "#EE7D5E", "#D982BB", 
          "#876ADD", "#5D6FBB", "#6BA7C6", "#728AC8", "#778093", 
          "#9DA3B9", "#FFE0C7", "#008685", "#BBDEDE", "#F08BB4"
        ])
        .style({
          fillOpacity: 1,
          lineWidth: 2,
          stroke: "#fff",
        })
        // .label('percent', {
        //   layout: [{ type: 'limit-in-plot', cfg: { action: 'ellipsis'/** 或 translate */ } }],
        //   content: (data) => {
        //     return `${data.item}: ${data.percent * 100}%`;
        //   },
        // })
        .state({
          active: {
            style: (element) => {
              const shape = element.shape;
              return {
                lineWidth: 4,
                stroke: shape.attr("fill"),
                strokeOpacity: shape.attr("fillOpacity"),
              };
            },
          },
        });

      // 移除图例点击过滤交互
      chart.removeInteraction("legend-filter");
      chart.interaction("element-active");
      chart.render();
      chart.on("element:statechange", (ev) => {
        const { state, stateStatus, element } = ev.gEvent.originalEvent;
        // 本示例只需要监听 active 的状态变化
        if (state === "active") {
          const data = element.getData();
          if (stateStatus) {
            // 更新 Annotation
            updateAnnotation(data);
          } else {
            // 隐藏 Annotation
            clearAnnotation();
          }
        }
      });
      this.pieChart = chart;
      // 绘制 annotation
      let lastItem;
      function updateAnnotation(data) {
        if (data.item !== lastItem) {
          innerView.annotation().clear(true);
          innerView.annotation().text({
            position: ["50%", "50%"],
            content: `${data.percent}`,
            style: {
              fontSize: 34,
              fontFamily: "DIN-PRO BOLD",
              fill: "#000",
              fontWeight: "bold",
              textAlign: "center",
            },
            offsetY: 4,
            offsetX: 0,
          });
          innerView.render(true);
          lastItem = data.item;
        }
      }

      // 清空 annotation
      function clearAnnotation() {
        innerView.annotation().clear(true);
        innerView.render(true);
        lastItem = null;
      }
    },

    dealData(data) {
      return data.map((item) => {
        const { value = 0 } = item;
        if (value == 0) {
          item.value = 0.0001;
        }
        return item;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.loading {
  width: 100%;
  height: 360px;
}

/deep/ div.g2-tooltip {
  font-size: 14px !important; 
}
</style>
